import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideNgxMask } from 'ngx-mask';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { environment } from '@gymautoc/common/environments/environment';
import { httpInterceptorProviders } from '@gymautoc/common/core/interceptors';
import { materialProviders } from '@gymautoc/common/shared/material-providers';
import { pipesProviders } from '@gymautoc/common/shared/pipes/pipes-providers';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule),
    ...httpInterceptorProviders,
    ...materialProviders,
    ...pipesProviders,
    provideAnimations(),
    provideNgxMask(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes),
  ],
})
  .catch(err => console.error(err));
